import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Amazon: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '21'} height={size ?? '21'} fill="none" viewBox="0 0 21 21" data-testid="amazon-icon">
      <g clipPath="url(#clip0Amazon)">
        <path
          fill={color ?? '#F90'}
          d="M18.02 16.849c-8.257 3.928-13.377.645-16.656-1.352-.204-.126-.55.026-.251.373 1.091 1.338 4.674 4.53 9.348 4.53s7.46-2.55 7.797-2.997c.338-.446.104-.684-.247-.541l.009-.013zm2.317-1.3c-.22-.29-1.347-.342-2.057-.256-.71.087-1.772.52-1.681.78.048.095.143.052.632 0 .49-.052 1.859-.22 2.145.152.285.372-.434 2.166-.568 2.456-.134.29.048.36.286.169a3.68 3.68 0 00.953-1.395c.286-.706.46-1.694.29-1.915v.009z"
        />
        <path
          fill={color ?? '#FFF'}
          fillRule="evenodd"
          d="M12.47 8.848c0 1.03.026 1.888-.498 2.807a2.165 2.165 0 01-1.828 1.2c-1.018 0-1.607-.776-1.607-1.915 0-2.257 2.018-2.664 3.933-2.664v.572zm2.668 6.45a.559.559 0 01-.628.06 6.538 6.538 0 01-1.516-1.763c-1.451 1.482-2.478 1.924-4.362 1.924-2.227 0-3.96-1.374-3.96-4.124a4.496 4.496 0 012.82-4.332c1.439-.633 3.466-.745 4.978-.918v-.343c0-.628.048-1.373-.32-1.914a1.772 1.772 0 00-1.486-.69c-1.01 0-1.91.516-2.127 1.586a.559.559 0 01-.46.485L5.51 4.997a.472.472 0 01-.394-.56c.593-3.11 3.4-4.045 5.917-4.045 1.3 0 2.971.342 3.985 1.3 1.3 1.2 1.165 2.806 1.165 4.552v4.12c0 1.239.516 1.784.997 2.456a.498.498 0 010 .702c-.542.433-1.503 1.3-2.032 1.754"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0Amazon">
          <path fill="#fff" d="M0 0H19.407V20H0z" transform="translate(.996 .4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Amazon;
